<template>
  <PageLayout :page-title="$t('contact.pageTitle')" banner-key="contact">
    <div class="contactDiv pd90">
      <div class="wrap">
        <div class="hdDiv" v-if="mainContact">
          <div class="nyTitle wow fadeInUp" v-if="companyTitle">
            <span class="f48">{{ companyTitle }}</span>
          </div>
          <div class="rowDiv">
            <div class="row">
              <div class="col-sm-4 col-12">
                <div class="conDiv">
                  <div class="icon flexcen"><i class="font_family icon-ditu"></i></div>
                  <div class="textDiv">
                    <span class="bold">{{ cardTitle('addressTitle', 'contact.addressCard') }}</span>
                    <p>{{ clean(mainContact.address) }}</p>
                    <a v-if="mainContact.mapUrl" :href="mainContact.mapUrl" target="_blank" rel="noopener">{{ $t('contact.navigate') }}</a>
                  </div>
                </div>
              </div>
              <div class="col-sm-4 col-12">
                <div class="conDiv">
                  <div class="icon flexcen"><i class="font_family icon-dianhua"></i></div>
                  <div class="textDiv">
                    <span class="bold">{{ cardTitle('phoneTitle', 'contact.hotlineCard') }}</span>
                    <a :href="'tel:' + hotlineTel">{{ mainContact.phone }}</a>
                    <p v-if="mainContact.serviceHours">{{ clean(mainContact.serviceHours) }}</p>
                  </div>
                </div>
              </div>
              <div class="col-sm-4 col-12">
                <div class="conDiv">
                  <div class="icon flexcen"><i class="font_family icon-youxiang"></i></div>
                  <div class="textDiv">
                    <span class="bold">{{ cardTitle('emailTitle', 'contact.emailCard') }}</span>
                    <a :href="'mailto:' + mainContact.email" class="f20">{{ mainContact.email }}</a>
                    <p v-if="mainContact.description">{{ clean(mainContact.description) }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="bdDiv" v-if="branches.length">
          <div class="nyTitle wow fadeInUp">
            <span class="f48">{{ branchSectionTitle }}</span>
          </div>
          <div class="rowDiv">
            <div class="row">
              <div v-for="item in branches" :key="item.id" class="col-sm-6 col-12">
                <div class="conDiv">
                  <div class="tit bold">{{ clean(item.name) }}</div>
                  <div class="text">
                    <div class="p flexsta" v-if="item.phone || item.wechatNo">
                      <i class="font_family icon-dianhua"></i>
                      <div class="pp">
                        <p v-if="item.phone">{{ $t('contact.hotline') }}{{ $t('colon') }}{{ item.phone }}</p>
                        <p v-if="item.wechatNo">{{ $t('contact.wechatService') }}{{ $t('colon') }}{{ item.wechatNo }}</p>
                      </div>
                    </div>
                    <div class="p flexsta" v-if="item.email">
                      <i class="font_family icon-youxiang"></i>
                      <div class="pp"><p>{{ item.email }}</p></div>
                    </div>
                    <div class="p flexsta" v-if="item.address">
                      <i class="font_family icon-ditu"></i>
                      <div class="pp"><p>{{ clean(item.address) }}</p></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </PageLayout>
</template>

<script>
import PageLayout from '@/components/hirays/PageLayout.vue'
import { listContactInfo } from '@/utils/http'
import { unwrapRows } from '@/utils/content'

export default {
  components: { PageLayout },
  data() {
    return {
      mainContact: null,
      branchSectionName: '',
      branches: []
    }
  },
  computed: {
    companyTitle() {
      if (this.mainContact && this.mainContact.companyTitle) return this.clean(this.mainContact.companyTitle)
      return ''
    },
    branchSectionTitle() {
      if (this.branchSectionName) return this.clean(this.branchSectionName)
      return this.$t('contact.branchesTitle')
    },
    hotlineTel() {
      if (!this.mainContact || !this.mainContact.phone) return ''
      return String(this.mainContact.phone).split('/')[0].trim().replace(/\s/g, '')
    }
  },
  created() {
    this.loadContact()
  },
  methods: {
    reloadCmsData() {
      this.loadContact()
    },
    clean(text) {
      return text ? this.$cleanBrand(text) : ''
    },
    cardTitle(field, i18nKey) {
      if (this.mainContact && this.mainContact[field]) return this.clean(this.mainContact[field])
      return this.$t(i18nKey)
    },
    async loadContact() {
      try {
        const locale = this.$i18n.locale
        const res = await listContactInfo({ status: 1, pageNum: 1, pageSize: 50 }, locale)
        const rows = unwrapRows(res)
        const header = rows.find(r => Number(r.type) === 1) || null
        const global = rows.find(r => Number(r.type) === 0) || null
        this.mainContact = this.mergeContactRows(header, global)
        this.branchSectionName = (header && header.name) || (this.mainContact && this.mainContact.branchSectionName) || ''
        this.branches = rows
          .filter(r => Number(r.type) === 2)
          .sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0))
      } catch (e) {
        this.mainContact = null
        this.branchSectionName = ''
        this.branches = []
      }
    },
    mergeContactRows(header, global) {
      if (!header && !global) return null
      const merged = { ...(global || {}), ...(header || {}) }
      if (!merged.companyTitle && global && global.companyTitle) merged.companyTitle = global.companyTitle
      if (!merged.address && global && global.address) merged.address = global.address
      if (!merged.email && global && global.email) merged.email = global.email
      if (!merged.phone && global && global.phone) merged.phone = global.phone
      return merged
    }
  }
}
</script>

